import "./FileInput.scss";

import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import PropTypes from "prop-types";

/**
 * Input component
 * @module
 * @param {string} [validationMessage] - Validation message - if field is invalid
 * @param {string} name - Name
 * @param {bool} [required] - Is input required?
 * @param {func} onChange - Function invoked on value change
 * @param {bool} [disabled] - Is input readonly?
 * @param {bool} [autofocus] - Should input be focused?
 * @param {bool} [readOnly] - Read only
 * @param {number} [tabIndex] - Input tabindex
 * @param {string} [accept] - What types of files FileInput accept
 * @param {bool} [multiple] - True/False if load multiple files
 * @param {string} [title] - Title
 */
const FileInputComponent = (props) => {
  const handleOnChange = (e) => {
    props.onChange(props.name, e.target.element);
  };

    const {
      disabled,
      validationMessage,
      required,
      onClick,
      autofocus,
      tabIndex,
      readOnly,
      accept,
      title,
      multiple,
    } = props;

    return (
      <React.Fragment>
        <Input
          data-testid={props.name || props.title}
          type="file"
          className={`input ${disabled ? "disabled-field" : ""} `}
          validationMessage={validationMessage || "Povinné"}
          required={required}
          onChange={handleOnChange}
          disabled={disabled}
          onClick={onClick}
          autoFocus={autofocus}
          tabIndex={tabIndex}
          readOnly={disabled || readOnly}
          accept={accept}
          title={title}
          multiple={multiple}
        />
      </React.Fragment>
    );
  
}

FileInputComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  validationMessage: PropTypes.string,
  accept: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  autofocus: PropTypes.bool,
  tabIndex: PropTypes.number,
  multiple: PropTypes.bool,
  title: PropTypes.string,
};

export default FileInputComponent;
